module.exports = __webpack_public_path__ + "img/10856_L.f2162395.png";